var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-1" },
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("e-store-combo", {
                    attrs: {
                      id: "price-suggestion-configuration-filter-store",
                      required: false,
                    },
                    model: {
                      value: _vm.filters.storeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "storeId", $$v)
                      },
                      expression: "filters.storeId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("e-search-sku", {
                    attrs: {
                      id: "price-suggestion-configuration-filter-sku",
                      required: false,
                      "only-active": true,
                      "include-fixed-assets": true,
                    },
                    model: {
                      value: _vm.filters.skuId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "skuId", $$v)
                      },
                      expression: "filters.skuId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.filterData },
        },
        [
          _c("b-table", {
            ref: "price-suggestion-configuration-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("PRICE_SUGGESTION_CONFIGURATION.NAME"),
                "female",
                _vm.queryExecuted
              ),
              fields: _vm.fields,
              items: _vm.sortedConfigurations,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(storeId)",
                fn: function (row) {
                  return [
                    !row.item.storeId
                      ? _c(
                          "b-badge",
                          { attrs: { variant: "light-secondary" } },
                          [_vm._v(" " + _vm._s(_vm.$t("Geral")) + " ")]
                        )
                      : _c("span", [
                          _vm._v(_vm._s(_vm.getStoreName(row.item.storeId))),
                        ]),
                  ]
                },
              },
              {
                key: "cell(skuId)",
                fn: function (row) {
                  return [
                    !row.item.skuId
                      ? _c(
                          "b-badge",
                          { attrs: { variant: "light-secondary" } },
                          [_vm._v(" " + _vm._s(_vm.$t("Geral")) + " ")]
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(row.item.skuId) +
                              _vm._s(
                                row.item.skuName ? " - " + row.item.skuName : ""
                              )
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "show-update": _vm.$can(
                          "Update",
                          "SkuPriceSuggestionConfiguration"
                        ),
                        "show-delete": _vm.$can(
                          "Delete",
                          "SkuPriceSuggestionConfiguration"
                        ),
                      },
                      on: {
                        update: function ($event) {
                          return _vm.showUpdateSidebar(row)
                        },
                        delete: function ($event) {
                          return _vm.deleteConfigurationLocal(row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("price-suggestion-configuration-sidebar", {
        ref: "price_suggestion_configuration_sidebar",
        on: { save: _vm.getData },
      }),
      _vm.$can("Create", "SkuPriceSuggestionConfiguration")
        ? _c("fab", {
            attrs: {
              "main-tooltip": _vm.$t(
                "Adicionar Configuração de Sugestão de Preço"
              ),
            },
            on: { click: _vm.showCreateSidebar },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }